<mat-card>
  <h2 translate>request.observations</h2>
  <form [formGroup]="observationsForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <div fxFlex="100" fxFlex.gt-sm="50">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.aditionalInformation</mat-label>
          <textarea
            id="textareaObservations"
            class="textareaObservations"
            formControlName="observations"
            matInput
            cols="100"
            rows="5"
          ></textarea>
        </mat-form-field>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="80">
        <mat-checkbox
          *ngIf="showObservations"
          id="checkCondicionesPasswordDialog"
          color="accent"
          [checked]="checked"
          (change)="checked = !checked"
          [(ngModel)]="checked"
          aria-label="Aceptar firma"
          name="checkCondiciones"
          formControlName="checkObservations"
        >
          <span translate>request.observationsCheck</span>
          <br />
          <span id="downloadCondicionesCheckPasswordDialog" *ngIf="checked">
            <a color="accent" href="javascript:void(0)" (click)="download()">
              {{ 'dialog.password.downloadAuth' | translate }}
            </a>
          </span>
        </mat-checkbox>
      </div>
    </div>
  </form>
</mat-card>
